import { render } from "./sliderTwo.vue?vue&type=template&id=6b6df3e0&scoped=true"
import script from "./sliderTwo.vue?vue&type=script&lang=js"
export * from "./sliderTwo.vue?vue&type=script&lang=js"

import "./sliderTwo.vue?vue&type=style&index=0&id=6b6df3e0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b6df3e0"]])

export default __exports__